/**
 * Equalize testimonial item heights
 * Sets all .testimonial-item heights to match the tallest one after content loads
 */
(function() {
    'use strict';

    const MOBILE_BREAKPOINT = 768;

    function equalizeTestimonialHeights() {
        const testimonialItems = document.querySelectorAll('.testimonial-item');
        
        if (testimonialItems.length === 0) {
            return;
        }
        
        // On mobile (576px and below), use max-content so each item keeps its natural height
        if (window.innerWidth <= MOBILE_BREAKPOINT) {
            testimonialItems.forEach(function(item) {
                item.style.height = 'max-content';
            });
            return;
        }
        
        // Reset heights to auto to get natural heights
        testimonialItems.forEach(function(item) {
            item.style.height = 'auto';
        });
        
        // Force a reflow to ensure heights are calculated
        void testimonialItems[0].offsetHeight;
        
        // Find the tallest item
        let maxHeight = 0;
        testimonialItems.forEach(function(item) {
            const height = item.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        
        // Only proceed if we have a valid height
        if (maxHeight <= 0) {
            return;
        }
        
        // Set all items to the maximum height
        testimonialItems.forEach(function(item) {
            item.style.height = maxHeight + 'px';
        });
    }

    // Run on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            // Delay to ensure layout is complete and heights are calculated
            setTimeout(equalizeTestimonialHeights, 300);
        });
    } else {
        setTimeout(equalizeTestimonialHeights, 300);
    }

    // Run on window resize with debounce
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(equalizeTestimonialHeights, 200);
    });

    // Also run after images load (in case they affect layout)
    window.addEventListener('load', function() {
        setTimeout(equalizeTestimonialHeights, 300);
    });
})();